"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const toolkit_1 = require("@reduxjs/toolkit");
const app_types_1 = require("pages/app.types");
const user_types_1 = require("./user.types");
const initialState = {
    isLoading: true,
    isLoadingDetail: true,
    isLoadingSubmit: false,
    isError: false,
    errorCode: 0,
    errorMessage: '',
    dataGrid: [],
    dataContractor: [],
    dataContractorNotKideco: [],
    dataContractorKideco: [],
    dataDepartment: [],
    dataRole: [],
    dataCheckpoint: [],
    mutationMode: false,
    isSuccess: false,
    dataItem: {
        id: '0',
        fullname: '',
        contractor_id: '',
        contractor_name: '',
        contractor_code: '',
        operator_access: [],
        department_id: '',
        department: '',
        operator_acces_id: '',
        operator_access_value: '',
        role: {
            id: '',
            name: ''
        },
        modified_by: '',
        modified_date: new Date(),
        created_date: new Date(),
        username: '',
        checkpoint_name: '',
        checkpoint_type: '',
        checkpoint: [],
        contractor: {
            id: '',
            contractor_name: ''
        },
        department_obj: {
            id: '',
            department_name: '',
        },
        is_active: {
            status: 'Active',
            value: true
        },
        role_id: '',
        role_name: ''
    },
    dataStates: {
        filterable: true,
        sortable: true,
        reorderable: false,
        scrollable: 'scrollable',
        skip: 0,
        take: 10,
        total: 0,
        sort: [{ field: 'modified_date', dir: 'desc' }]
    }
};
const userReducer = (0, toolkit_1.createReducer)(initialState, {
    [app_types_1.appTypes.RESET_LOADING]: () => {
        return Object.assign({}, initialState);
    },
    [user_types_1.userTypes.SET_DATA_GRID]: (state, action) => {
        const { dataGrid, count } = action.payload;
        return Object.assign(Object.assign({}, state), { dataGrid, isLoading: false, dataStates: Object.assign(Object.assign({}, state.dataStates), { total: count }) });
    },
    [user_types_1.userTypes.ON_PAGE_CHANGE]: (state, action) => {
        const { dataStates } = action.payload;
        return Object.assign(Object.assign({}, state), { dataStates, isLoading: true });
    },
    [user_types_1.userTypes.ON_FILTER_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStates: Object.assign(Object.assign({}, state.dataStates), { filter: action.payload, skip: initialState.dataStates.skip }) });
    },
    [user_types_1.userTypes.ON_MUTATION_CLICK]: (state, action) => {
        const { dataItem, mutationMode, isSuccess, isLoadingSubmit } = action.payload;
        return Object.assign(Object.assign({}, state), { isSuccess,
            isLoadingSubmit, dataItem: dataItem ? dataItem : initialState.dataItem, mutationMode: mutationMode });
    },
    [user_types_1.userTypes.ON_DELETE]: (state) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, mutationMode: false });
    },
    [user_types_1.userTypes.ON_RESET]: (state) => {
        return Object.assign(Object.assign({}, state), { isSuccess: true, isLoading: true, mutationMode: false });
    },
    [user_types_1.userTypes.SET_ERROR]: (state, action) => {
        return Object.assign(Object.assign(Object.assign({}, state), action.payload), { isLoading: false, isSuccess: false, isLoadingSubmit: false, isLoadingDetail: false });
    },
    [user_types_1.userTypes.GET_DETAIL]: (state, action) => {
        const { dataContractorNotKideco, dataContractorKideco, dataDepartment, dataRole } = action.payload;
        return Object.assign(Object.assign({}, state), { dataContractorNotKideco,
            dataContractorKideco,
            dataDepartment,
            dataRole });
    },
    [user_types_1.userTypes.GET_CHECKPOINT]: (state, action) => {
        const { dataCheckpoint } = action.payload;
        return Object.assign(Object.assign({}, state), { dataCheckpoint, isLoadingDetail: false });
    },
    [user_types_1.userTypes.ON_SAVE_DATAITEM]: (state, action) => {
        const { dataItem, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { isSuccess, mutationMode: false, isLoading: true, isLoadingSubmit: isSuccess, dataItem: initialState.dataItem, dataGrid: state.dataGrid.map(item => {
                if (item.id === dataItem.id)
                    return dataItem;
                return item;
            }) });
    }
});
exports.default = userReducer;
